import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api, mediaUrl } from "../lib/api";
import { PageHero, Loader } from "../components/ui-bits";
import { Reveal } from "../components/Reveal";

const BG = "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Gallery() {
  const [items, setItems] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="gallery-page">
      <PageHero
        eyebrow="Media Gallery"
        title="Moments, milestones & ventures in pictures."
        subtitle="A visual archive from across the SRAM & MRAM Group — products, events and initiatives worldwide."
        bg={BG}
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {items === null ? <Loader label="Loading gallery" /> : items.length === 0 ? (
          <p className="text-slate-500 font-mono py-20 text-center">Gallery is being populated.</p>
        ) : (
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
            {items.map((g, i) => (
              <Reveal key={g.id} delay={(i % 8) * 0.03}>
                <button
                  onClick={() => setActive(g)}
                  data-testid={`gallery-item-${g.id}`}
                  className="mb-4 w-full break-inside-avoid rounded-xl overflow-hidden border border-slate-800 hover:border-emerald-500/50 transition-colors group block"
                >
                  <img src={mediaUrl(g.url)} alt={g.title} loading="lazy"
                    className="w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </button>
              </Reveal>
            ))}
          </div>
        )}
      </section>

      {active && (
        <div className="fixed inset-0 z-[70] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" data-testid="gallery-lightbox-close"><X className="w-8 h-8" /></button>
          <img src={mediaUrl(active.url)} alt={active.title} className="max-h-[85vh] max-w-full rounded-lg" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
